import * as urljoin from 'url-join'

const host = (process.env.REACT_APP_LOCAL___API || window.location.host);

export function register(email, password, name) {
  return postData(urljoin(host, 'api', 'register'), {
    email,
    password,
    name
  })
}

export function login(email, password) {
  return postData(urljoin(host, 'api', 'login'), { email, password })
}

export function logout(all) {
  return postData(urljoin(host, 'api', `logout`), { all })
}

export function refreshToken() {
  return postData(urljoin(host, 'api', 'refresh'), {})
}

// Calling the reset endpoint which will run the password reset from the backend
// which will send a reset email containing the reset token.
export function requestReset(email) {
  return postData(urljoin(host, 'api', 'accounts/password/reset'), {
    email
  })
}

export function resendVerificationEmail(email) {
  return postData(urljoin(host, 'api', 'accounts/verify'), {
    email
  })
}

export function verifyEmail(token) {
  return postData(urljoin(host, 'api', 'accounts/verify'), {
    token
  })
}

export function getConfig() {
  return getData(urljoin(host, 'api', 'config'))
}

async function postData(url, data = {}) {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })

  if (!response.ok) {
    return response.json().then(err => {
      throw err
    })
  } else {
    return response.json()
  }
}

async function getData(url) {

  console.log(url);
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  })

  if (!response.ok) {
    return response.json().then(err => {
      throw err
    })
  } else {
    return response.json()
  }
}
